
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bCanw", function(module, exports) {

$parcel$export(module.exports, "AccessDetailsDialog", () => $9ab331bcf4180daf$export$47f45cf4d14749ea);
/* AccessDetailsDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2jjxD = parcelRequire("2jjxD");

var $xQxzY = parcelRequire("xQxzY");

var $ekolh = parcelRequire("ekolh");

var $9hlns = parcelRequire("9hlns");

var $fT2ta = parcelRequire("fT2ta");

var $inPa6 = parcelRequire("inPa6");

var $1kHsc = parcelRequire("1kHsc");

var $6ZdUl = parcelRequire("6ZdUl");

var $dS8Wr = parcelRequire("dS8Wr");

var $eyam8 = parcelRequire("eyam8");

var $kDHiY = parcelRequire("kDHiY");
const $9ab331bcf4180daf$var$PAGE_SIZE = 20; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ab331bcf4180daf$var$LoadingSpinnerContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _4t3i1cbm",
            __cmplp.className
        ])
    });
});
const $9ab331bcf4180daf$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9ab331bcf4180daf$var$LoadingSpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        size: "medium"
    }));
function $9ab331bcf4180daf$var$mergeFetchMoreSpaceResults(prev, { fetchMoreResult: fetchMoreResult }) {
    const nodes = [
        ...prev?.spacePermissions?.subjectsWithPermissions?.nodes || [],
        ...fetchMoreResult?.spacePermissions?.subjectsWithPermissions?.nodes || []
    ];
    const pageInfo = fetchMoreResult?.spacePermissions?.subjectsWithPermissions?.pageInfo || null;
    return {
        ...prev,
        spacePermissions: {
            ...prev.spacePermissions,
            subjectsWithPermissions: {
                ...prev.spacePermissions.subjectsWithPermissions,
                nodes: nodes,
                pageInfo: pageInfo
            }
        }
    };
}
function $9ab331bcf4180daf$var$mergeFetchMoreContentResults(prev, { fetchMoreResult: fetchMoreResult }) {
    const nodes = [
        ...prev?.contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes || [],
        ...fetchMoreResult?.contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes || []
    ];
    const pageInfo = fetchMoreResult?.contentPermissions?.subjectsWithEffectiveContentPermissions?.pageInfo || null;
    const userCount = fetchMoreResult?.contentPermissions?.subjectsWithEffectiveContentPermissions?.userCount || 0;
    const groupCount = fetchMoreResult?.contentPermissions?.subjectsWithEffectiveContentPermissions?.groupCount || 0;
    return {
        ...prev,
        contentPermissions: {
            ...prev?.contentPermissions,
            subjectsWithEffectiveContentPermissions: {
                ...prev?.contentPermissions?.subjectsWithEffectiveContentPermissions,
                pageInfo: pageInfo,
                nodes: nodes,
                userCount: userCount,
                groupCount: groupCount
            }
        }
    };
}
const $9ab331bcf4180daf$export$47f45cf4d14749ea = ({ onClose: onClose, accessDetailsParams: accessDetailsParams })=>{
    const [filterText, setFilterText] = (0, $gwFzn.useState)('');
    const [appliedFilterText, setAppliedFilterText] = (0, $gwFzn.useState)('');
    const debouncedSetFilterText = (0, $gwFzn.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(setAppliedFilterText, 200), []);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        debouncedSetFilterText(filterText);
    }, [
        filterText,
        debouncedSetFilterText
    ]);
    const { spaceKey: spaceKey, restrictingContentId: restrictingContentId, hasInheritedRestrictions: hasInheritedRestrictions, experience: experience } = accessDetailsParams;
    const { data: spaceAccessDetails, loading: spaceAccessDetailsLoading, error: spaceAccessDetailsError, fetchMore: spaceAccessDetailsFetchMore } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $6ZdUl.SpaceAccessDetailsQuery), {
        variables: {
            spaceKey: spaceKey,
            first: $9ab331bcf4180daf$var$PAGE_SIZE,
            filterText: appliedFilterText
        },
        skip: hasInheritedRestrictions
    });
    const handleSpaceAccessDetailsFetchMore = (0, $gwFzn.useCallback)((nextPageCursor)=>{
        spaceAccessDetailsFetchMore({
            variables: {
                after: nextPageCursor
            },
            updateQuery: $9ab331bcf4180daf$var$mergeFetchMoreSpaceResults
        });
    }, [
        spaceAccessDetailsFetchMore
    ]);
    const { data: contentAccessDetails, loading: contentAccessDetailsLoading, error: contentAccessDetailsError, fetchMore: contentAccessDetailsFetchMore } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $dS8Wr.ContentAccessDetailsQuery), {
        variables: {
            contentId: restrictingContentId,
            filterText: appliedFilterText,
            first: $9ab331bcf4180daf$var$PAGE_SIZE
        },
        skip: !hasInheritedRestrictions
    });
    const handleContentAccessDetailsFetchMore = (0, $gwFzn.useCallback)((nextPageCursor)=>{
        contentAccessDetailsFetchMore({
            variables: {
                after: nextPageCursor
            },
            updateQuery: $9ab331bcf4180daf$var$mergeFetchMoreContentResults
        });
    }, [
        contentAccessDetailsFetchMore
    ]);
    if (spaceAccessDetailsError || contentAccessDetailsError) {
        if (spaceAccessDetailsError) {
            experienceTracker.fail({
                name: experience,
                error: spaceAccessDetailsError
            });
            throw spaceAccessDetailsError;
        }
        if (contentAccessDetailsError) {
            experienceTracker.fail({
                name: experience,
                error: contentAccessDetailsError
            });
            throw contentAccessDetailsError;
        }
    }
    const isLoading = contentAccessDetailsLoading || spaceAccessDetailsLoading; // Don't render spinner when search bar entires are querying results
    const [initialLoadComplete, setInitialLoadComplete] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (!contentAccessDetailsLoading && !spaceAccessDetailsLoading) {
            if (!contentAccessDetailsError && !spaceAccessDetailsError) {
                setInitialLoadComplete(true);
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        source: experience,
                        actionSubjectId: 'ViewSpaceAccessModal',
                        action: 'viewed'
                    }
                }).fire();
            }
        }
    }, [
        contentAccessDetailsLoading,
        spaceAccessDetailsLoading,
        contentAccessDetailsError,
        spaceAccessDetailsError,
        createAnalyticsEvent,
        experience
    ]); //TODO: The body should likely be split into two components, one for content access and one for space access,
    //      either could be passed to a body wrapper component.  That way, there aren't multiple query's data in the same file.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        onClose: onClose,
        testId: "space-access-details.drilldown"
    }, isLoading && !initialLoadComplete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9ab331bcf4180daf$var$LoadingSpinner, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fT2ta.default), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyam8.AccessDetailsDialogHeader), {
            filterText: filterText,
            appliedFilterText: appliedFilterText,
            setFilterText: setFilterText,
            onClose: onClose,
            hasInheritedRestrictions: hasInheritedRestrictions,
            spaceInfo: spaceAccessDetails,
            contentInfo: contentAccessDetails,
            isLoading: isLoading,
            ...props
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDHiY.AccessDetailsDialogBody), {
            filterText: filterText,
            spaceInfo: spaceAccessDetails,
            contentInfo: contentAccessDetails,
            hasInheritedRestrictions: hasInheritedRestrictions,
            handleSpaceAccessDetailsFetchMore: handleSpaceAccessDetailsFetchMore,
            handleContentAccessDetailsFetchMore: handleContentAccessDetailsFetchMore,
            isLoading: isLoading,
            ...props
        }))));
};

});
parcelRegister("6ZdUl", function(module, exports) {

$parcel$export(module.exports, "SpaceAccessDetailsQuery", () => $8c049344c499ca02$export$1ae46fa57836d423);

var $d2LG0 = parcelRequire("d2LG0");
const $8c049344c499ca02$export$1ae46fa57836d423 = (0, $d2LG0.default)`query SpaceAccessDetailsQuery($spaceKey:String!$first:Int$after:String$filterText:String){space(key:$spaceKey){id key name icon{path(type:ABSOLUTE)isDefault}type}spacePermissions(spaceKey:$spaceKey){subjectsWithPermissions(first:$first after:$after filterText:$filterText){groupCount userCount nodes{permissions subjectKey{id displayName principalType user{accountId displayName email permissionType profilePicture{width height isDefault path(type:ABSOLUTE)}}group{id name permissionType}}}pageInfo{hasNextPage endCursor}}}}`;

});

parcelRegister("dS8Wr", function(module, exports) {

$parcel$export(module.exports, "ContentAccessDetailsQuery", () => $64e15a24736a4e1b$export$a04422dcf09c6c50);

var $d2LG0 = parcelRequire("d2LG0");
const $64e15a24736a4e1b$export$a04422dcf09c6c50 = (0, $d2LG0.default)`query ContentAccessDetailsQuery($contentId:ID!$first:Int$after:String$filterText:String){contentPermissions(contentId:$contentId){subjectsWithEffectiveContentPermissions(first:$first after:$after filterText:$filterText){groupCount userCount nodes{id permissions type displayName group{id name permissionType}user{accountId displayName email permissionType profilePicture{width height isDefault path(type:ABSOLUTE)}}}pageInfo{hasNextPage endCursor}}}singleContent(id:$contentId){id title type links{webui}}}`;

});

parcelRegister("eyam8", function(module, exports) {

$parcel$export(module.exports, "AccessDetailsDialogHeader", () => $b9842932469a1ca3$export$a96f881061864293);
/* AccessDetailsDialogHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $eEA8O = parcelRequire("eEA8O");

var $4noo5 = parcelRequire("4noo5");

var $bPdpL = parcelRequire("bPdpL");

var $7yDmn = parcelRequire("7yDmn");

var $jluld = parcelRequire("jluld");

var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $25ZwL = parcelRequire("25ZwL");

var $i2ukN = parcelRequire("i2ukN");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b9842932469a1ca3$var$HeaderLayout = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $b9842932469a1ca3$var$HeaderContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _2lx2vrvc _4cvr1h6o _n3tdu2gc",
            __cmplp.className
        ])
    });
});
const $b9842932469a1ca3$var$TitleContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _2lx2vrvc _4cvr1h6o _n3tdpxbi _jq8g1tcg _14hp1tcg",
            __cmplp.className
        ])
    });
});
const $b9842932469a1ca3$var$titleTextStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b9842932469a1ca3$var$SearchIconWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41b66 _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $b9842932469a1ca3$var$ModalHeaderWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_jhqfpxbi",
            __cmplp.className
        ])
    });
});
const $b9842932469a1ca3$var$i18n = (0, $2nPZH.defineMessages)({
    clearFilterLabel: {
        id: "space-access-details.access-details-dialog.clear-filter",
        defaultMessage: "Clear selection"
    },
    countOfIndividualsSuffix: {
        id: "space-access-details.access-details-dialog.count-of-groups-and-individuals-suffix",
        defaultMessage: "and {countOfIndividuals, plural, one {# individual} other {# individuals}}"
    },
    countOfGroups: {
        id: "space-access-details.access-details-dialog.count-of-groups",
        defaultMessage: "Search {countOfGroups, plural, one {# group} other {# groups}}"
    },
    countOfIndividuals: {
        id: "space-access-details.access-details-dialog.count-of-individuals",
        defaultMessage: "Search {countOfIndividuals, plural, one {# individual} other {# individuals}}"
    }
});
const $b9842932469a1ca3$export$a96f881061864293 = ({ hasInheritedRestrictions: hasInheritedRestrictions, onClose: onClose, filterText: filterText, setFilterText: setFilterText, spaceInfo: spaceInfo, contentInfo: contentInfo, isLoading: isLoading, appliedFilterText: appliedFilterText })=>{
    const intl = (0, $dBxQj.default)();
    const handleFilterTextChange = (event)=>{
        setFilterText(event.currentTarget.value);
    };
    let countOfIndividuals;
    let countOfGroups;
    if (hasInheritedRestrictions) {
        countOfIndividuals = contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.userCount;
        countOfGroups = contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.groupCount;
    } else {
        countOfIndividuals = spaceInfo?.spacePermissions?.subjectsWithPermissions?.userCount || 0;
        countOfGroups = spaceInfo?.spacePermissions?.subjectsWithPermissions?.groupCount || 0;
    }
    let placeholder;
    // Input cleared but filter is still there - prevent flashing of placeholder
    if (isLoading || appliedFilterText && !filterText) placeholder = '';
    else {
        if (countOfIndividuals && countOfGroups) placeholder = `${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfGroups, {
            countOfGroups: countOfGroups
        })} ${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfIndividualsSuffix, {
            countOfIndividuals: countOfIndividuals
        })}`;
        else if (countOfGroups) placeholder = intl.formatMessage($b9842932469a1ca3$var$i18n.countOfGroups, {
            countOfGroups: countOfGroups
        });
        else placeholder = intl.formatMessage($b9842932469a1ca3$var$i18n.countOfIndividuals, {
            countOfIndividuals: countOfIndividuals
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b9842932469a1ca3$var$ModalHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b9842932469a1ca3$var$HeaderLayout, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b9842932469a1ca3$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        "aria-label": "Back",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
            label: ""
        }),
        onClick: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b9842932469a1ca3$var$titleTextStyles
    }, hasInheritedRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "space-access-details.access-details-dialog.restricting-page-header",
        defaultMessage: "Who has access to the parent item"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "space-access-details.access-details-dialog.restricting-space-header",
        defaultMessage: "Who has access to this space"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b9842932469a1ca3$var$HeaderContainer, null, !hasInheritedRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i2ukN.SpaceDescription), {
        spaceInfo: spaceInfo,
        isLoading: isLoading
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $25ZwL.ContentDescription), {
        contentInfo: contentInfo,
        isLoading: isLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4noo5.default), {
        "aria-label": placeholder,
        autoFocus: true,
        placeholder: placeholder,
        value: filterText,
        onChange: handleFilterTextChange,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b9842932469a1ca3$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            spacing: "spacious",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, Boolean(filterText) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            "aria-label": intl.formatMessage($b9842932469a1ca3$var$i18n.clearFilterLabel),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: "",
                color: "var(--ds-icon-subtle, #626F86)"
            }),
            onClick: ()=>setFilterText('')
        }))
    }))));
};

});
parcelRegister("25ZwL", function(module, exports) {

$parcel$export(module.exports, "ContentDescription", () => $aef3854608361508$export$9435e8786e5b8e8f);
/* ContentDescription.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $13WX1 = parcelRequire("13WX1");

var $8lYIw = parcelRequire("8lYIw");

var $jlIaF = parcelRequire("jlIaF");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aef3854608361508$var$PageDescriptionContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $aef3854608361508$var$PageDescriptionLabel = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19bvu2gc _1e0c1o8l _1jtp18uv _1wxd8stv _1cbrnqa1 _71j91fxt",
            __cmplp.className
        ])
    });
});
const $aef3854608361508$export$9435e8786e5b8e8f = ({ contentInfo: contentInfo })=>{
    const path = contentInfo?.singleContent?.links?.webui;
    const pageUrl = `${(0, $jlIaF.CONTEXT_PATH)}${path}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($aef3854608361508$var$PageDescriptionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $13WX1.default), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($aef3854608361508$var$PageDescriptionLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8lYIw.Link), {
        to: pageUrl,
        target: "_blank",
        testId: "parent-page-link"
    }, contentInfo?.singleContent?.title)));
};

});

parcelRegister("i2ukN", function(module, exports) {

$parcel$export(module.exports, "SpaceDescription", () => $3f0be1a6cd78921a$export$cfbfa0f452e3e9c);
/* SpaceDescription.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $esRft = parcelRequire("esRft");

var $8lYIw = parcelRequire("8lYIw");

var $1NBp8 = parcelRequire("1NBp8");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f0be1a6cd78921a$var$SpaceDescriptionContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $3f0be1a6cd78921a$var$SpaceDescriptionLabel = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19bvu2gc _1e0c1o8l _syaz1fxt _fzbr18uv _17ku8stv _1rj5nqa1 _ii851fxt",
            __cmplp.className
        ])
    });
});

const $3f0be1a6cd78921a$export$cfbfa0f452e3e9c = ({ spaceInfo: spaceInfo, isLoading: isLoading })=>{
    const spaceKey = spaceInfo?.space?.key;
    const spaceUrl = spaceKey ? (0, $1NBp8.SPACE_OVERVIEW).toUrl({
        spaceKey: spaceKey
    }) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3f0be1a6cd78921a$var$SpaceDescriptionContainer, null, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
        src: spaceInfo?.space?.type !== 'personal' ? spaceInfo?.space?.icon?.path : (parcelRequire("jVqNO")),
        size: "xsmall",
        appearance: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3f0be1a6cd78921a$var$SpaceDescriptionLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8lYIw.Link), {
        to: spaceUrl,
        target: "_blank",
        testId: "space-overview-link"
    }, spaceInfo?.space?.name)));
};

});
parcelRegister("jVqNO", function(module, exports) {
module.exports = new URL("personal_space.c63f5733.png", import.meta.url).toString();

});



parcelRegister("kDHiY", function(module, exports) {

$parcel$export(module.exports, "AccessDetailsDialogBody", () => $c2ed31214ba9baeb$export$4459f2b09704bade);
/* AccessDetailsDialogBody.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");

var $esRft = parcelRequire("esRft");

var $gEpEw = parcelRequire("gEpEw");

var $lebfc = parcelRequire("lebfc");

var $1DHa6 = parcelRequire("1DHa6");

var $4B2M3 = parcelRequire("4B2M3");

var $kr1Wj = parcelRequire("kr1Wj");

var $a7PZ9 = parcelRequire("a7PZ9");

var $7hNjr = parcelRequire("7hNjr");

var $kIelD = parcelRequire("kIelD");

var $iwQKB = parcelRequire("iwQKB");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c2ed31214ba9baeb$var$TableContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1s5rglyw _rhyvglyw _19zf14no _1mtpglyw _zvc5ze3t _1ce5ze3t _1leoze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c2ed31214ba9baeb$var$PrincipalName = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c2ed31214ba9baeb$var$ExternalCollaboratorUserLozengeWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c2ed31214ba9baeb$var$Email = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
}); // matching Avatar: 32 - size of the medium icon + the icon component ads wrapper with 2px margin
const $c2ed31214ba9baeb$var$PeopleGroupIconWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1ssb _18s8v77o _1e0c116y _4cvr1h6o _1bah1h6o _bfhk1v33 _1bsbzwfg _4t3izwfg",
            __cmplp.className
        ])
    });
});
const $c2ed31214ba9baeb$var$TableHeaderSpan = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19itidpf _18s8ze3t _1reo15vq _18m915vq _1yt4ze3t _ogto7mnp _mkrz1wmp _4t3it94y _kqswstnw _1bsbt94y _slp31giz",
            __cmplp.className
        ])
    });
});
const $c2ed31214ba9baeb$export$46a08817349aa0d5 = {
    cells: [
        {
            key: 'avatar',
            content: ''
        },
        {
            key: 'principal',
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                id: "space-access-details.access-details-table.header.principal",
                defaultMessage: "User/group"
            }, (tableHeaderText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c2ed31214ba9baeb$var$TableHeaderSpan, null, tableHeaderText))
        }
    ]
};
function $c2ed31214ba9baeb$var$getTableRowCells({ type: type, id: id, displayName: displayName, secondLine: secondLine, avatarUrl: avatarUrl, isGuest: isGuest, filterText: filterText }) {
    const tablePrincipalAvatar = type === (0, $a7PZ9.PRINCIPAL_TYPE).USER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
        src: avatarUrl,
        appearance: "circle",
        size: "medium",
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c2ed31214ba9baeb$var$PeopleGroupIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }));
    const groupId = type === (0, $a7PZ9.PRINCIPAL_TYPE).GROUP ? id : null;
    return {
        key: `${type}-${id}`,
        cells: [
            {
                key: 'avatar',
                content: tablePrincipalAvatar
            },
            {
                key: 'principal',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c2ed31214ba9baeb$var$PrincipalWithSearchHighlight, {
                    displayName: displayName || '',
                    filterText: filterText,
                    email: secondLine || '',
                    isGuest: isGuest
                }), Boolean(groupId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hNjr.GroupCountComponent), {
                    groupId: groupId
                }))
            }
        ]
    };
}
function $c2ed31214ba9baeb$var$formatSubjects({ subjectList: subjectList, filterText: filterText }) {
    if (!subjectList) return [];
    return subjectList.map((item)=>$c2ed31214ba9baeb$var$getTableRowCells({
            ...item,
            filterText: filterText
        }));
}
const $c2ed31214ba9baeb$var$PrincipalWithSearchHighlight = ({ displayName: displayName, email: email, isGuest: isGuest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c2ed31214ba9baeb$var$PrincipalName, null, displayName), isGuest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c2ed31214ba9baeb$var$ExternalCollaboratorUserLozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kr1Wj.ExternalCollaboratorUserLozenge), null))), Boolean(email) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c2ed31214ba9baeb$var$Email, null, email));
};
function $c2ed31214ba9baeb$var$parseSpaceInfoSubjects(spaceInfo) {
    return (spaceInfo?.spacePermissions?.subjectsWithPermissions?.nodes || []).map((item)=>{
        if (item?.subjectKey?.principalType === (0, $iwQKB.PrincipalType).USER) return {
            id: item?.subjectKey?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).USER,
            displayName: item?.subjectKey?.displayName,
            avatarUrl: item?.subjectKey?.user?.profilePicture?.path || '',
            secondLine: item?.subjectKey?.user?.email,
            isGuest: item?.subjectKey?.user?.permissionType === (0, $iwQKB.SitePermissionType).EXTERNAL
        };
         // else not a user, so it must be a group
        return {
            id: item?.subjectKey?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).GROUP,
            displayName: item?.subjectKey?.displayName,
            isGuest: item?.subjectKey?.group?.permissionType === (0, $iwQKB.SitePermissionType).EXTERNAL
        };
    });
}
function $c2ed31214ba9baeb$var$parseContentInfoSubjects(contentInfo) {
    return (contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes || []).map((item)=>{
        if (item?.type === (0, $a7PZ9.PRINCIPAL_TYPE).USER) return {
            id: item?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).USER,
            displayName: item?.displayName,
            avatarUrl: item?.user?.profilePicture?.path || '',
            secondLine: item?.user?.email,
            isGuest: item?.user?.permissionType === (0, $kIelD.SitePermissionType).EXTERNAL
        };
         // else not a user, so it must be a group
        return {
            id: item?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).GROUP,
            displayName: item?.displayName,
            isGuest: item?.group?.permissionType === (0, $kIelD.SitePermissionType).EXTERNAL
        };
    });
}
const $c2ed31214ba9baeb$export$4459f2b09704bade = ({ filterText: filterText, spaceInfo: spaceInfo, contentInfo: contentInfo, hasInheritedRestrictions: hasInheritedRestrictions, handleContentAccessDetailsFetchMore: handleContentAccessDetailsFetchMore, handleSpaceAccessDetailsFetchMore: handleSpaceAccessDetailsFetchMore, isLoading: isLoading })=>{
    const subjectList = hasInheritedRestrictions ? $c2ed31214ba9baeb$var$parseContentInfoSubjects(contentInfo) : $c2ed31214ba9baeb$var$parseSpaceInfoSubjects(spaceInfo);
    const hasNextPage = hasInheritedRestrictions ? Boolean(contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.pageInfo?.hasNextPage) : Boolean(spaceInfo?.spacePermissions?.subjectsWithPermissions?.pageInfo?.hasNextPage);
    const nextPageCursor = hasInheritedRestrictions ? contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.pageInfo?.endCursor : spaceInfo?.spacePermissions?.subjectsWithPermissions?.pageInfo?.endCursor;
    const handleFetchMore = hasInheritedRestrictions ? handleContentAccessDetailsFetchMore : handleSpaceAccessDetailsFetchMore;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c2ed31214ba9baeb$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gEpEw.default), {
        head: $c2ed31214ba9baeb$export$46a08817349aa0d5,
        rows: $c2ed31214ba9baeb$var$formatSubjects({
            subjectList: subjectList,
            filterText: filterText
        }),
        isFixedSize: true
    }), !isLoading && hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4B2M3.ObservableSpinner), {
        onScrollTo: ()=>{
            handleFetchMore(nextPageCursor);
        },
        cursor: nextPageCursor,
        testId: "access-details-spinner",
        observerOptions: {
            root: null,
            rootMargin: '0px',
            threshold: 0.05
        }
    })));
};

});
parcelRegister("a7PZ9", function(module, exports) {

$parcel$export(module.exports, "PRINCIPAL_TYPE", () => $e0035cf7a1f09457$export$6162b8d0c6ca280e);
var $e0035cf7a1f09457$export$6162b8d0c6ca280e = /*#__PURE__*/ function(PRINCIPAL_TYPE) {
    PRINCIPAL_TYPE["GROUP"] = "group";
    PRINCIPAL_TYPE["USER"] = "user";
    PRINCIPAL_TYPE["TEAM"] = "team";
    PRINCIPAL_TYPE["EMAIL"] = "email";
    return PRINCIPAL_TYPE;
}({});

});

parcelRegister("7hNjr", function(module, exports) {

$parcel$export(module.exports, "GroupCountComponent", () => $2600cade940e6680$export$70eb39fe733e9d05);
/* GroupCountComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $xQxzY = parcelRequire("xQxzY");

var $4jR19 = parcelRequire("4jR19");

var $510ht = parcelRequire("510ht");
const $2600cade940e6680$var$GroupCountLine = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81o8v _syaz131l",
            __cmplp.className
        ])
    });
});
const $2600cade940e6680$var$useGroupCount = (id)=>{
    const { loading: loading, data: data } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $510ht.AccessDetailsGroupCountsQuery), {
        variables: {
            groupIdList: id !== undefined ? [
                id
            ] : null
        },
        skip: !id
    });
    if (loading) return null;
    const count = data?.groupCounts?.groupCounts?.[0]?.value;
    if (typeof count === 'number') return count;
};
const $2600cade940e6680$export$70eb39fe733e9d05 = ({ groupId: groupId })=>{
    const count = $2600cade940e6680$var$useGroupCount(groupId);
    if (!count) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2600cade940e6680$var$GroupCountLine, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "space-access-details.access-details-table.header.principal",
        defaultMessage: "{count, plural, one {# person} other {# people}}",
        values: {
            count: count
        }
    }));
};

});
parcelRegister("510ht", function(module, exports) {

$parcel$export(module.exports, "AccessDetailsGroupCountsQuery", () => $e04d31b662216aab$export$d813fdedcf9b0cd);

var $d2LG0 = parcelRequire("d2LG0");
const $e04d31b662216aab$export$d813fdedcf9b0cd = (0, $d2LG0.default)`query AccessDetailsGroupCountsQuery($groupIdList:[String]){groupCounts(groupIds:$groupIdList){groupCounts{key value}}}`;

});


parcelRegister("kIelD", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $7d044ed031f84140$export$8995abb8169b2cb8);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $7d044ed031f84140$export$7c562381fe299c25 = /*#__PURE__*/ function(ContentPermissionType) {
    ContentPermissionType["EDIT"] = "EDIT";
    ContentPermissionType["VIEW"] = "VIEW";
    return ContentPermissionType;
}({});
var $7d044ed031f84140$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});

parcelRegister("iwQKB", function(module, exports) {

$parcel$export(module.exports, "PrincipalType", () => $b35a748af9142b8f$export$39adac38571da5a2);
$parcel$export(module.exports, "SitePermissionType", () => $b35a748af9142b8f$export$8995abb8169b2cb8);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $b35a748af9142b8f$export$39adac38571da5a2 = /*#__PURE__*/ function(PrincipalType) {
    PrincipalType["GROUP"] = "GROUP";
    PrincipalType["USER"] = "USER";
    return PrincipalType;
}({});
var $b35a748af9142b8f$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $b35a748af9142b8f$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});

});



parcelRegister("lbXO9", function(module, exports) {

$parcel$export(module.exports, "usePublicLinkDisablePageMutation", () => $b66f63d9e0e0a7b3$export$7eac4bd73184138d);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $1KmJq = parcelRequire("1KmJq");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1IGAH = parcelRequire("1IGAH");
const $b66f63d9e0e0a7b3$var$i18n = (0, $2nPZH.defineMessages)({
    success: {
        id: "public-links.usePublicLinkDisablePageMutation.success.title",
        defaultMessage: "Public link is now off for this content."
    },
    errorTitle: {
        id: "public-links.usePublicLinkDisablePageMutation.error.title",
        defaultMessage: "We couldn\u2019t turn off the public link."
    },
    errorBody: {
        id: "public-links.usePublicLinkDisablePageMutation.error.body",
        defaultMessage: "Open the Share dialog to check the current status, or to turn off the public link."
    }
});
const $b66f63d9e0e0a7b3$export$7eac4bd73184138d = ({ pageId: pageId, onCompleted: onCompleted, onError: onError, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [disablePublicLinkMutation] = (0, $1KmJq.useMutation)((0, $d2LG0.default)`mutation usePublicLinkDisablePageMutationPublicLinkDisablePageMutation($pageId:ID!){disablePublicLinkForPage(pageId:$pageId){pageId}}`, {
        refetchQueries: [
            {
                query: (0, $1IGAH.PublicLinkPageQuery),
                variables: {
                    pageId: pageId
                }
            }
        ],
        onCompleted: ()=>{
            flags.showFlag({
                id: 'revokeFromRestrictionsFlagId',
                title: formatMessage($b66f63d9e0e0a7b3$var$i18n.success),
                type: 'success-circle',
                close: 'auto'
            });
            onCompleted();
        },
        onError: (error)=>{
            flags.showFlag({
                id: 'revokeFromRestrictionsErrorFlagId',
                title: formatMessage($b66f63d9e0e0a7b3$var$i18n.errorTitle),
                description: formatMessage($b66f63d9e0e0a7b3$var$i18n.errorBody),
                type: 'error',
                close: 'auto'
            });
            onError(error);
        }
    });
    const disablePublicLinkForPage = (pageId)=>()=>disablePublicLinkMutation({
                variables: {
                    pageId: pageId
                }
            });
    return {
        disablePublicLinkForPage: disablePublicLinkForPage(pageId)
    };
};

});


//# sourceMappingURL=RestrictionsDialog.62c8692f.js.map
